import PropTypes from 'prop-types'
import React from 'react'

const OriginalsPortfolio = ({ portfolio }) => (
  <div className='originals-portfolio'>
    <div className='originals-portfolio__media'>
      {portfolio.map(({ node }) => (
        <div className='originals-portfolio__media--item' key={node.id}>
          <div className='originals-portfolio__image'>
            <img
              src={node.image_desktop.url}
              alt={node.title}
            />
          </div>
        </div>
      ))}
    </div>
  </div>
)

OriginalsPortfolio.propTypes = {
  portfolio: PropTypes.array.isRequired
}

export default OriginalsPortfolio



// WEBPACK FOOTER //
// ./src/components/originals-portfolio.js